import { Currency } from './currency';

export class TransactionCurrencyDropdownValue {
  currency: Currency;
  key: string;
  value: number;
}
